import RlLogo from 'module/ui/assets/svgs/rocketlane_icon_standard.svg';
import SalesforceLogo from 'module/ui/assets/svgs/salesforce-logo.svg';
import { Avatar } from '@rocketlane/ui';
import { Space, Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;
const FieldTitle = styled(Text)`
  width: var(--width-md);
  display: inline-block;
`;

export const DisplayDynamicValue = ({
  valueStr,
  label,
  boldText,
  forceSalesforceLogo,
}: {
  valueStr?: string;
  label: string;
  boldText?: boolean;
  forceSalesforceLogo?: boolean;
}) => (
  <Space>
    {forceSalesforceLogo || valueStr?.startsWith('${trigger.') ? (
      <Avatar src={SalesforceLogo} shape="square" size={20} />
    ) : (
      <Avatar src={RlLogo} shape="square" size={20} />
    )}
    <FieldTitle strong={boldText} ellipsis={{ tooltip: true }}>
      {label}
    </FieldTitle>
  </Space>
);
